import { HowToPlaySceneBase } from "src/games/shared/scenes/HowToPlaySceneBase";
import { Games } from "src/constants/Games";
import { MainScene } from "./MainScene";
import { GameIntroScene } from "./GameIntro";

export class HowToPlayScene extends HowToPlaySceneBase {
    constructor() {
        super();
        this.gameRef = Games.CareerFair;
        this.mainScene = MainScene;
        this.gameIntroScene = GameIntroScene;
        this.gameObjectiveTextKey = "CareerFair.Phaser.HowToPlay.objectiveText";
        this.howToPlayOnComputerTextKey = "CareerFair.Phaser.HowToPlay.computerInstructions";
        this.howToPlayOnTabletTextKey = "CareerFair.Phaser.HowToPlay.tabletInstructions";
    }
}



// WEBPACK FOOTER //
// ./src/games/CareerFairGame/scenes/IntroductionScene.ts